module.exports = __webpack_public_path__ + "static/assets/2cef0a4b3ddbd7d0cf43740862444fc6.png";